import { Link } from "react-router-dom";
import "../home/home.css";

const QUICK_LINKS = [
  { label: "Home", to: "/" },
  { label: "Our Services", to: "/mutual-fund" },
  { label: "About Us", to: "/about" },
  { label: "Blogs", to: "/blog" },
  { label: "Calculator", to: "/SipCalculator" },
  { label: "Contact Us", to: "/contact" },
];

const SERVICES = [
  { label: "Mutual Funds", to: "/mutual-fund" },
  { label: "SIP Planning", to: "/SipCalculator" },
  { label: "Bonds", to: "/mutual-fund" },
  { label: "Loan Advisory", to: "/loan" },
  { label: "Retirement Planning", to: "/RetirementCalculator" },
  { label: "Wealth Management", to: "/mutual-fund" },
];

const RESOURCES = [
  { label: "Market Insights", to: "/blog" },
  { label: "Blog", to: "/blog" },
  { label: "Calculator", to: "/SipCalculator" },
  { label: "FAQs", to: "/contact" },
  { label: "Terms & Conditions", to: "/termsandconditions" },
];

const SOCIALS = [
  { icon: "fa-facebook-f", href: "https://facebook.com", label: "Facebook" },
  { icon: "fa-linkedin-in", href: "https://linkedin.com", label: "LinkedIn" },
  { icon: "fa-x-twitter", href: "https://x.com", label: "X" },
  { icon: "fa-instagram", href: "https://instagram.com", label: "Instagram" },
];

const scrollTop = () => window.scrollTo({ top: 0, behavior: "instant" });

export default function Footer() {
  return (
    <footer className="gps-footer">
      <div className="gps-footer-inner">
        <div className="gps-footer-grid">
          <div className="gps-footer-brand">
            <Link to="/" onClick={scrollTop} className="gps-footer-logo">
              <img
                src="/images/gpslogo.png"
                alt="GPS Global Portfolio Solutions"
              />
            </Link>
            <p className="gps-footer-blurb">
              Empowering investors to grow wealth through smart strategies and
              global opportunities.
            </p>
            <div className="gps-footer-socials">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.label}
                >
                  <i className={`fa-brands ${s.icon}`} />
                </a>
              ))}
            </div>
          </div>

          <nav className="gps-footer-col" aria-label="Quick links">
            <h4>Quick Links</h4>
            <ul>
              {QUICK_LINKS.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} onClick={scrollTop}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="gps-footer-col" aria-label="Our services">
            <h4>Our Services</h4>
            <ul>
              {SERVICES.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} onClick={scrollTop}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="gps-footer-col" aria-label="Resources">
            <h4>Resources</h4>
            <ul>
              {RESOURCES.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} onClick={scrollTop}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="gps-footer-col gps-footer-contact">
            <h4>Contact Us</h4>
            <ul>
              <li>
                <i className="fa-solid fa-phone" aria-hidden="true" />
                <a href="tel:+918460028397">+91 84600 28397</a>
              </li>
              <li>
                <i className="fa-solid fa-envelope" aria-hidden="true" />
                <a href="mailto:info@gpsfinvest.com">info@gpsfinvest.com</a>
              </li>
              <li>
                <i className="fa-solid fa-location-dot" aria-hidden="true" />
                <a
                  href="https://maps.app.goo.gl/zrcxbYQYP8Aw8Dbs7"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  1018, Anand Mangal 3, Near Apollo Hospital, Ambawadi,
                  Ahmedabad, Gujarat - 380054
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="gps-footer-bottom">
          <p>© 2025 GPS Finvest. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
